import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NgxFileDropEntry } from 'ngx-file-drop';
import { SubSink } from 'subsink';
import * as uuid from 'uuid';
import { ATTACHMENT_UPLOAD_STATUS } from '../../../../core/constants/attachments-upload-statue.enum';
import { GlobalConstants } from '../../../../core/constants/globals';
import { SNACKBAR_ALERT_TYPES } from '../../../../core/constants/snackbar-alert-types.enum';
import { TuwaiqConfig } from '../../../../core/constants/tuwaiq.config';
import { AttachmentFile } from '../../../../core/models/attachment-file.model';
import { AttachmentsService } from '../../../../core/services/attachments.service';
import { NumericHandlingService } from '../../../../core/services/numeric-handling.service';
import { RequestViewService } from '../../../../core/services/request-view.service';
import { SnackbarAlertService } from '../../../../core/services/snackbar-alert.service';
import { REQUEST_TYPE } from '../upload-attachments/upload-attachments.component';

@Component({
    selector: 'app-add-attachments',
    templateUrl: './add-attachments.component.html',
    styleUrls: ['./add-attachments.component.css']
})
export class AddAttachmentsComponent implements OnInit, OnDestroy, OnChanges {
    @Input() requestId: number;
    @Input() reportId: number;
    @Input() action;
    @Input() onlyUploadImages: boolean;
    @Input() userAttachment;
    @Input() isRemoveAttachment;
    // @Input() isRequired: boolean;
    @Input() isDisable: boolean;
    @Input() isNotDisplayLabel: boolean;
    @Input() uploadAttachmentRequestType: REQUEST_TYPE;
    @Output() passAttachmentList = new EventEmitter<any>(); //TODO: model;
    files: NgxFileDropEntry[] = [];
    attachmentList: AttachmentFile[] = [];
    addAttachment = GlobalConstants.ADD_ATTACHMENT_ACTION;
    maxAttachmentSize = TuwaiqConfig.MAX_ATTACHMENT_SIZE;
    maxAttachmentSizeInMegaBytes = TuwaiqConfig.MAX_ATTACHMENT_SIZE;
    successSnackbarAlert = SNACKBAR_ALERT_TYPES.SUCCESS;
    errorSnackbarAlert = SNACKBAR_ALERT_TYPES.ERROR;
    allowedAttachmentExtensions;
    allowedAttachmentExtensionsWithoutDot;
    subs = new SubSink();
    @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;
    constructor(
        private numericHandlingService: NumericHandlingService,
        private snackbarAlertService: SnackbarAlertService,
        private requestViewService: RequestViewService,
        private attachmentsService: AttachmentsService
    ) {}
    ngOnInit(): void {
        this.handleMaxAttachmentSize();
        this.handleAcceptedAttachmentExtensions();
        this.subscribeToRemoveAttachment();
        this.subscribeToClearAttachmentList();
        this.subscribeToAttachmentUpload();
    }
    ngOnChanges(changes: SimpleChanges) {
        if (this.isRemoveAttachment === true) {
            this.attachmentList = [];
        }
    }
    handleMaxAttachmentSize() {
        this.maxAttachmentSizeInMegaBytes = this.numericHandlingService.convertBytesToMegaBytes(this.maxAttachmentSize);
    }

    handleAcceptedAttachmentExtensions() {
        this.allowedAttachmentExtensions = this.onlyUploadImages ? TuwaiqConfig.IMAGES_ALLOWED_EXTENSIONS : TuwaiqConfig.ATTACHMENTS_ALLOWED_EXTENSIONS;
        this.allowedAttachmentExtensionsWithoutDot = this.allowedAttachmentExtensions.map(extension => '.' + extension);
    }

    public dropped(files: NgxFileDropEntry[]) {
        this.files = files;
        for (const droppedFile of files) {
            if (droppedFile.fileEntry.isFile) {
                const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
                fileEntry.file((file: AttachmentFile) => {
                    if (this.validateFile(file)) {
                       file = this.handleTypeNotDetected(file) as AttachmentFile;
                       file['id'] = uuid.v4();
                       file.hasError = false;
                       file.uploadStatus = ATTACHMENT_UPLOAD_STATUS.NEW;
                         this.attachmentList.unshift(file);
                    } else {
                        file = this.handleTypeNotDetected(file) as AttachmentFile;
                        file['id'] = uuid.v4();
                        file.uploadStatus = ATTACHMENT_UPLOAD_STATUS.FAILED;
                        file.hasError = true;
                        this.attachmentList.unshift(file);
                    }

                    this.handleAttachmentObjSendToParent();
                    this.attachmentsService.onAddAttachment.next(this.attachmentList); // pass to upload attachment
                });
            }
        }
    }
    handleTypeNotDetected(file: File): File {
        let extension = file.name.split('.').pop();  // Get file extension
        let newFile: File; // Declare newFile variable to hold the new File object
        
        // Check if the file extension is supported
        if (['eml', 'msg', 'pst', 'ost', 'mbox', 'dbx', 'nsf', 'doc'].includes(extension)) {
            // Switch case based on the extension
            switch (extension) {
                case 'msg':
                    newFile = new File([file], file.name, { type: 'application/vnd.ms-outlook' });
                    break;
    
                case 'mbox':
                    newFile = new File([file], file.name, { type: 'application/mbox' });
                    break;
    
                case 'pst':
                    newFile = new File([file], file.name, { type: 'application/vnd.ms-outlook' });
                    break;
    
                case 'ost':
                    newFile = new File([file], file.name, { type: 'application/vnd.ms-outlook' });
                    break;
    
                case 'dbx':
                    newFile = new File([file], file.name, { type: 'application/x-outlook-express' });
                    break;
    
                case 'nsf':
                    newFile = new File([file], file.name, { type: 'application/vnd.lotus-notes' });
                    break;
    
                case 'doc':
                    newFile = new File([file], file.name, { type: 'application/msword' });
                    break;
    
                default:
                    newFile = new File([file], file.name, { type: 'message/rfc822' });
                    break;
            }
        } else {
            console.error('Unsupported file type');
            newFile = file; // Return the original file if not supported
        }
    
        return newFile;
    }
    
 
    handleAttachmentObjSendToParent() {
        const isAttachmentListValid = this.attachmentsService.isAttachmentListValid(this.attachmentList);
        const attachmentObj = {
            isAttachmentListValid: isAttachmentListValid,
            attachmentList: this.attachmentList
        };
        this.passAttachmentList.next(attachmentObj); // pass to parent to validate buttons
    }

    validateFile(file: AttachmentFile) {
        if (file.size > this.maxAttachmentSize) {
            file.errorMessage = 'maximumFileSizeWarning';
            this.snackbarAlertService.openSnackBar('someFilesExceedsMaximumFileSizeWarning', this.errorSnackbarAlert);
            return false;
        }

        const fileExtensionAllowed = this.allowedAttachmentExtensionsWithoutDot.find(v => file.name.toLowerCase().includes(v));
        if (!fileExtensionAllowed) {
            file.errorMessage = 'fileNotAllowed';
            this.snackbarAlertService.openSnackBar('fileNotAllowed', this.errorSnackbarAlert);
            return false;
        }
        return true;
    }

    subscribeToRemoveAttachment() {
        this.subs.sink = this.requestViewService.removeAttachment.subscribe((attachmentToRemove: AttachmentFile) => {
            const index = this.attachmentList.findIndex(v => v.id === attachmentToRemove.id);
            if (index !== -1) {
                this.attachmentList.splice(index, 1);
            }
            this.handleAttachmentObjSendToParent();
            this.attachmentsService.onAddAttachment.next(this.attachmentList);
        });
    }

    subscribeToClearAttachmentList() {
        this.subs.sink = this.requestViewService.clearAttachments.subscribe(() => {
            this.attachmentList = [];
        });
    }

    subscribeToAttachmentUpload() {
        this.subs.sink = this.attachmentsService.onAttachmentUpload.subscribe(() => {
            this.handleAttachmentObjSendToParent();
        });
    }
    handlePaste(event: ClipboardEvent) {
        const items = event.clipboardData.items;
        if (items) {
            for (let i = 0; i < items.length; i++) {
                const blob = items[i].getAsFile();
                this.uploadFile(blob);
            }
        }
    }

    uploadFile(image: File) {
        const file = image as AttachmentFile;
        if (this.validateFile(file)) {
            file['id'] = uuid.v4();
            file.uploadStatus = ATTACHMENT_UPLOAD_STATUS.NEW;
            file.hasError = false;
            this.attachmentList.unshift(file);
        } else {
            file['id'] = uuid.v4();
            file.uploadStatus = ATTACHMENT_UPLOAD_STATUS.FAILED;
            file.hasError = true;
            this.attachmentList.unshift(file);
        }

        this.handleAttachmentObjSendToParent();
        this.attachmentsService.onAddAttachment.next(this.attachmentList); // pass to upload attachment
    }
    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }
}
